import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { error } from 'pdf-lib';
import {
  saveTestStruct,
  ScoreDetail,
  ScoringPattern,
  SectionScoreDetail,
  TestTypeTest,
} from 'src/app/constants/constants';
import { GlobalApiService } from 'src/app/services/global-api.service';

@Component({
  selector: 'app-test-scoring-pattern',
  templateUrl: './test-scoring-pattern.component.html',
  styleUrls: ['./test-scoring-pattern.component.scss'],
})
export class TestScoringPatternComponent implements OnInit {
  @Input() testId: number = 0;

  @Output() scoringPatternVisibility = new EventEmitter<boolean>();

  previousTestId: number = 0;

  testDetails: saveTestStruct | null = null;

  testSections: any;

  sectionsList: any[] = [];

  topicsAndSubTopicsList: any[] = [];

  formControlsPrepared: boolean = false;

  yo: any[] = [];

  private readonly notifier: NotifierService;

  previousTestList: TestTypeTest[] = [];

  // previousTestId: TestTypeTest | undefined = undefined;

  moduleList: ScoringPattern = {
    testId: 0,
    sectionScoreDetails: [],
  };

  previousModuleList: ScoringPattern = {
    testId: 0,
    sectionScoreDetails: [],
  };

  scoringPatternForm: FormGroup = new FormGroup({});

  totalQuestions: number = 0;

  isGet: boolean = false;

  isDataLoading: boolean = false;

  isSaveAllowed: boolean = true;

  isBeingSaved: boolean = false;

  constructor(
    private globalApiService: GlobalApiService,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    console.log(this.testId);
    // this.previousTestId = this.testId;
    this.getTestScoringPattern(false);
  }

  getTestScoringPattern(usingPreviousTest: boolean) {
    this.isDataLoading = true;
    this.scoringPatternForm = new FormGroup({});
    let testId = usingPreviousTest ? this.previousTestId : this.testId;
    this.globalApiService.getTestScoringPattern(testId).subscribe({
      next: (res: ScoringPattern) => {
        console.log(res);
        let moduleListArr = usingPreviousTest
          ? this.previousModuleList
          : this.moduleList;
        moduleListArr = res;
        let moduleArr: SectionScoreDetail[] = [];
        let mergedArrays: any = {};

        for (let i = 0; i < moduleListArr.sectionScoreDetails.length; i++) {
          let currentObj = moduleListArr.sectionScoreDetails[i];
          let sectionId = currentObj.sectionId;
          let scoreDetails = currentObj.scoreDetails;
          console.log(scoreDetails);

          if (mergedArrays.hasOwnProperty(sectionId)) {
            scoreDetails = scoreDetails.filter(
              (scoreDetailObj) => scoreDetailObj.rawScore !== 0
            );
            mergedArrays[sectionId] =
              mergedArrays[sectionId].concat(scoreDetails);
          } else {
            mergedArrays[sectionId] = scoreDetails.slice();
          }
        }

        moduleArr = Object.keys(mergedArrays).map((sectionId) => ({
          sectionId: parseInt(sectionId),
          scoreDetails: mergedArrays[sectionId],
        }));

        moduleArr.forEach((sectionScoreDetail, sectionScoreDetailIndex) => {
          sectionScoreDetail.scoreDetails.sort(
            (firstScoreDetail, secondScoreDetail) =>
              firstScoreDetail.rawScore - secondScoreDetail.rawScore
          );
          sectionScoreDetail.scoreDetails.forEach(
            (scoreDetailObj, scoreDetailObjIndex) => {
              scoreDetailObj.rawScore = scoreDetailObjIndex;
            }
          );
          for (
            let scoreDetailIndex = 0;
            scoreDetailIndex < sectionScoreDetail.scoreDetails.length;
            scoreDetailIndex++
          ) {
            if (
              sectionScoreDetail.scoreDetails[scoreDetailIndex].rawScore ===
                0 &&
              sectionScoreDetail.scoreDetails[scoreDetailIndex].tscId === null
            ) {
              sectionScoreDetail.scoreDetails[scoreDetailIndex].score = 100;
            }
            break;
          }
        });

        if (usingPreviousTest) {
          this.previousModuleList.testId = res.testId;
          this.previousModuleList.sectionScoreDetails = moduleArr;
          // ** loop to mix the scores of previous test based if sectionId matches
          this.moduleList.sectionScoreDetails.forEach(
            (sectionScoreDetail, sectionScoreDetailIndex) => {
              this.previousModuleList.sectionScoreDetails.forEach(
                (
                  previousSectionScoreDetail,
                  previousSectionScoreDetailIndex
                ) => {
                  if (
                    previousSectionScoreDetail.sectionId ===
                    sectionScoreDetail.sectionId
                  ) {
                    previousSectionScoreDetail.scoreDetails.forEach(
                      (previousScoreDetail, previousScoreDetailIndex) => {
                        sectionScoreDetail.scoreDetails.forEach(
                          (scoreDetail, scoreDetailIndex) => {
                            if (
                              previousScoreDetail.rawScore ===
                              scoreDetail.rawScore
                            ) {
                              scoreDetail.score = previousScoreDetail.score;
                            }
                          }
                        );
                      }
                    );
                  }
                }
              );
            }
          );
        } else {
          this.moduleList.testId = res.testId;
          this.moduleList.sectionScoreDetails = moduleArr;
        }

        console.log(moduleArr);
        moduleListArr.sectionScoreDetails = moduleArr;
        console.log(this.moduleList);

        this.isGet = true;
        this.getTest();
      },
      error: (err: Error) => {
        this.isDataLoading = false;
        // this.isGet = false;
        // this.getTest();
      },
    });
  }

  makeFormControls() {
    console.log('triggered', this.testId);
    console.log(this.moduleList);
    this.sectionsList.forEach((section, sectionIndex) => {
      console.log(section);
      this.moduleList.sectionScoreDetails.forEach(
        (sectionScoreDetailObj, sectionScoreDetailObjIndex) => {
          if (
            section.scoring_section_type_id === sectionScoreDetailObj.sectionId
          ) {
            sectionScoreDetailObj.moduleName = section.scoring_section_name;
            sectionScoreDetailObj.scoreDetails.forEach(
              (scoreDetailObj, scoreDetailObjIndex) => {
                this.scoringPatternForm.addControl(
                  `${sectionScoreDetailObj.moduleName as string}-${
                    scoreDetailObj.rawScore
                  }`,
                  new FormControl(
                    scoreDetailObj.score > 0 ||
                    (scoreDetailObj.rawScore === 0 &&
                      this.previousTestId !== this.testId) ||
                    scoreDetailObj.tscId !== null
                      ? scoreDetailObj.score
                      : '',
                    [Validators.pattern('^[0-9]*$')]
                  )
                );
                console.log(
                  `${sectionScoreDetailObj.moduleName as string}-${
                    scoreDetailObj.rawScore
                  }`
                );
              }
            );
          }
        }
      );
    });
    console.log(this.scoringPatternForm);
    this.isDataLoading = false;
    this.formControlsPrepared = true;
    console.log(this.scoringPatternForm.valid, this.isSaveAllowed);
  }

  getTest() {
    if (this.testId > 0) {
      this.globalApiService.getCreatedTest(this.testId).subscribe({
        next: (testDetails: saveTestStruct) => {
          console.log(testDetails);
          this.testDetails = testDetails;
          this.testDetails.testModuleDetails.forEach(
            (testModule, testoduleIndex) => {
              this.totalQuestions =
                this.totalQuestions +
                (testModule.totalMCQ + testModule.totalFreeText);
            }
          );
          this.globalApiService
            .getTestsByTestTypeId(testDetails.testTypeId)
            .subscribe({
              next: (tests: TestTypeTest[]) => {
                this.previousTestList = tests;
                this.previousTestList.filter(
                  (previousTest) => previousTest.is_conversion_available
                );
              },
              error: (err: Error) => {
                console.log(err);
                this.notifier.notify('error', 'Unable to get tests');
              },
            });
          this.getTestSectionsByTestTypeId();
        },
        error: (err: Error) => {
          console.log(err);
          this.notifier.notify('error', 'Unable to get the test details');
          this.isDataLoading = false;
        },
      });
    }
  }

  getTestSectionsByTestTypeId() {
    // let res = await this.globalApiService.getSectionsByTestTypeIdSync(
    //   this.testDetails?.testTypeId as number
    // );
    // this.globalApiService.getSectionsByTestTypeId(
    //     this.testDetails?.testTypeId as number
    //   ).subscribe({;
    // console.log(JSON.parse(res.data));
    // this.sectionsList = JSON.parse(res.data);
    // this.sectionsList.forEach((section, sectionIndex) => {
    //   section['topicAndSubTopicsList'] = [];
    //   this.getTopicsAndSubTopicsByTestSectionId(section.tst_id);
    // });
    // console.log(this.sectionsList);
    // console.log(lol);
    this.globalApiService
      .getSectionsByTestTypeId(this.testDetails?.testTypeId as number)
      .subscribe({
        next: (res: any) => {
          console.log(JSON.parse(res.data));
          this.sectionsList = JSON.parse(res.data);

          console.log(this.sectionsList);
          // setTimeout(() => {
          //   this.combineModules();
          // }, 1000);
          // this.sectionsList.forEach((section, sectionIndex) => {
          //   console.log(section);
          //   section['topicAndSubTopicsList'] = [];
          //   setTimeout(() => {
          //     this.getTopicsAndSubTopicsByTestSectionId(section.tst_id);
          //   }, 5000);
          // });
          if (!this.isGet) {
            for (
              let sectionIndex = 0;
              sectionIndex < this.sectionsList.length;
              sectionIndex++
            ) {
              this.sectionsList[sectionIndex]['topicAndSubTopicsList'] = [];
              this.getTopicsAndSubTopicsByTestSectionId(
                this.sectionsList[sectionIndex].tst_id
              );
            }
          } else {
            this.makeFormControls();
          }
        },
        error: (err: Error) => {
          console.log(err);
          this.isDataLoading = false;
        },
      });
  }

  getTopicsAndSubTopicsByTestSectionId(testSectionId: number) {
    this.globalApiService
      .getTopicsAndSubTopicsByTestSection(testSectionId)
      .subscribe({
        next: (res: any) => {
          console.log(JSON.parse(res.data));
          let parsedData = JSON.parse(res.data);
          console.log(this.sectionsList);
          this.sectionsList.forEach((section, sectionIndex) => {
            console.log(section);
            console.log(section.tst_id === testSectionId);
            if (section.tst_id === testSectionId) {
              section['topicAndSubTopicsList'] = parsedData.result;
              if (section.topicAndSubTopicsList.length > 0) {
                let sectionScoreDetailObj: SectionScoreDetail = {
                  sectionId: section.tst_id,
                  moduleName: section.scoring_section_name,
                  scoreDetails: [],
                };
                if (this.moduleList.sectionScoreDetails.length === 0) {
                  this.moduleList.sectionScoreDetails.push(
                    sectionScoreDetailObj
                  );
                } else {
                  for (
                    let i = 0;
                    i < this.moduleList.sectionScoreDetails.length;
                    i++
                  ) {
                    if (
                      this.moduleList.sectionScoreDetails[i].sectionId !==
                      sectionScoreDetailObj.sectionId
                    ) {
                      this.moduleList.sectionScoreDetails.push(
                        sectionScoreDetailObj
                      );
                      break;
                    }
                    break;
                  }
                }
              }
              // ** Logic for making the scoring pattern structure in frontend
              this.testDetails?.testModuleDetails.forEach(
                (testModule, testModuleIndex) => {
                  testModule.subTopicQuestionDetails.forEach(
                    (testSubTopic, testSubTopicIndex) => {
                      console.log(testSubTopic);
                      if (section.topicAndSubTopicsList.length > 0) {
                        section.topicAndSubTopicsList.forEach(
                          (
                            topicAndSubTopics: any,
                            topicAndSubTopicsIndex: any
                          ) => {
                            console.log(topicAndSubTopics);
                            if (topicAndSubTopics.subtopics) {
                              topicAndSubTopics.subtopics.forEach(
                                (subTopic: any, subTopicIndex: any) => {
                                  console.log(subTopic);
                                  console.log(
                                    testSubTopic.subTopicId,
                                    subTopic.subtopic_id
                                  );
                                  if (
                                    testSubTopic.subTopicId ===
                                    subTopic.subtopic_id
                                  ) {
                                    testSubTopic.questionSpecifications.forEach(
                                      (questionSpec, questionSpecIndex) => {
                                        console.log(questionSpec.noOfQuestions);
                                        this.yo.push(
                                          questionSpec.noOfQuestions
                                        );
                                        for (
                                          let noOfQuestions = 0;
                                          noOfQuestions <
                                          questionSpec.noOfQuestions;
                                          noOfQuestions++
                                        ) {
                                          this.moduleList.sectionScoreDetails.forEach(
                                            (
                                              sectionScoreDetail,
                                              sectionScoreDetailIndex
                                            ) => {
                                              console.log(
                                                section.tst_id,
                                                sectionScoreDetail.sectionId
                                              );
                                              if (
                                                section.tst_id ===
                                                sectionScoreDetail.sectionId
                                              ) {
                                                let scoreDetailObj: ScoreDetail =
                                                  {
                                                    rawScore: 0,
                                                    score: 0,
                                                  };
                                                if (
                                                  sectionScoreDetail
                                                    .scoreDetails.length > 0
                                                ) {
                                                  scoreDetailObj.rawScore =
                                                    scoreDetailObj.rawScore +
                                                    sectionScoreDetail
                                                      .scoreDetails[
                                                      sectionScoreDetail
                                                        .scoreDetails.length - 1
                                                    ].rawScore;
                                                }
                                                sectionScoreDetail.scoreDetails.push(
                                                  scoreDetailObj
                                                );
                                                this.scoringPatternForm.addControl(
                                                  `${
                                                    sectionScoreDetail.moduleName as string
                                                  }-${scoreDetailObj.rawScore}`,
                                                  new FormControl('', [
                                                    Validators.pattern(
                                                      '^[0-9]*$'
                                                    ),
                                                  ])
                                                );
                                              }
                                            }
                                          );
                                        }
                                      }
                                    );
                                  }
                                }
                              );
                            } else {
                              console.log('No subtopics');
                            }
                          }
                        );
                      } else {
                        console.log('list is empty');
                      }
                    }
                  );
                  // this.moduleList.sectionScoreDetails =
                  //   this.moduleList.sectionScoreDetails.filter(
                  //     (sectionScoreDetailObj) =>
                  //       sectionScoreDetailObj.scoreDetails.length > 0
                  //   );
                  this.cleanModuleList();
                }
              );
            }
          });
          console.log(this.yo);
          console.log(this.scoringPatternForm);
          console.log(this.sectionsList);
        },
        error: (err: any) => {
          console.log(err.msg);
          // this.sectionsList.forEach((section, sectionIndex) => {
          //   if (section.tst_id === testSectionId) {
          //     section['topicAndSubTopicsList'] = [];
          //   }
          // });
        },
      });
  }

  cleanModuleList() {
    let sectionScoreDetailQuestions: number = 0;
    this.moduleList.sectionScoreDetails.forEach(
      (sectionScoreDetail, sectionScoreDetailIndex) => {
        sectionScoreDetailQuestions =
          sectionScoreDetailQuestions + sectionScoreDetail.scoreDetails.length;
      }
    );
    if (this.totalQuestions === sectionScoreDetailQuestions) {
      this.moduleList.sectionScoreDetails =
        this.moduleList.sectionScoreDetails.filter(
          (sectionScoreDetailObj) =>
            sectionScoreDetailObj.scoreDetails.length > 0
        );
    }
  }

  getFormControl(moduleName: string, rawScore: number): AbstractControl {
    const form = this.scoringPatternForm;
    let control = form.controls[`${moduleName}-${rawScore}`];
    return control;
  }

  makeSaveStruct() {
    console.log(this.scoringPatternForm.valid);
    this.moduleList.testId = this.testId;
    this.moduleList.sectionScoreDetails.forEach(
      (sectionScoreDetailObj, sectionScoreDetailObjIndex) => {
        sectionScoreDetailObj.scoreDetails.forEach(
          (scoreDetailObj, scoreDetailObjIndex) => {
            if (
              scoreDetailObj.rawScore === 0 ||
              this.getFormControl(
                sectionScoreDetailObj.moduleName!,
                scoreDetailObj.rawScore
              ).value > 0
            ) {
              let formControlValue = this.getFormControl(
                sectionScoreDetailObj.moduleName!,
                scoreDetailObj.rawScore
              ).value;
              scoreDetailObj.score =
                formControlValue === '' ? 0 : parseInt(formControlValue);
            } else {
              this.getFormControl(
                sectionScoreDetailObj.moduleName!,
                scoreDetailObj.rawScore
              ).setErrors({ value: 'Must be greater than 0' });
            }
          }
        );
      }
    );
    console.log(this.moduleList);
    if (this.scoringPatternForm.valid && this.isSaveAllowed) {
      this.isBeingSaved = true;
      this.globalApiService.saveTestScoringPattern(this.moduleList).subscribe({
        next: (res: any) => {
          console.log(res);
          this.notifier.notify(
            'success',
            'Succssfully saved the scoring pattern'
          );
          this.isBeingSaved = false;
          this.scoringPatternVisibility.emit(false);
        },
        error: (err: Error) => {
          console.log(err);
          this.notifier.notify('error', 'Unable to save the scoring pattern');
          this.isBeingSaved = false;
          this.scoringPatternVisibility.emit(true);
        },
      });
    }
    console.log(this.scoringPatternForm.valid);
    console.log(this.moduleList);
  }

  lol(yo: any) {
    console.log(yo);
  }

  // combineModules() {
  //   let yo: any[] = [];
  //   this.sectionsList.forEach((section, sectionIndex) => {
  //     console.log(section);
  //     // if (section.topicAndSubTopicsList.length > 0) {
  //     let sectionScoreDetailObj: SectionScoreDetail = {
  //       sectionId: section.tst_id,
  //       moduleName: section.scoring_section_name,
  //       scoreDetails: [],
  //     };
  //     if (this.moduleList.sectionScoreDetails.length === 0) {
  //       this.moduleList.sectionScoreDetails.push(sectionScoreDetailObj);
  //     } else {
  //       for (let i = 0; i < this.moduleList.sectionScoreDetails.length; i++) {
  //         if (
  //           this.moduleList.sectionScoreDetails[i].sectionId !==
  //           sectionScoreDetailObj.sectionId
  //         ) {
  //           this.moduleList.sectionScoreDetails.push(sectionScoreDetailObj);
  //           break;
  //         }
  //         break;
  //       }
  //     }
  //     // }
  //   });
  //   this.testDetails?.testModuleDetails.forEach(
  //     (testModule, testModuleIndex) => {
  //       testModule.subTopicQuestionDetails.forEach(
  //         (testSubTopic, testSubTopicIndex) => {
  //           this.sectionsList.forEach((section, sectionIndex) => {
  //             // let sectionScoreDetailObj: SectionScoreDetail = {
  //             //   sectionId: section.tst_id,
  //             //   moduleName: section.scoring_section_name,
  //             //   scoreDetails: [],
  //             // };
  //             // if (this.moduleList.sectionScoreDetails.length === 0) {
  //             //   this.moduleList.sectionScoreDetails.push(sectionScoreDetailObj);
  //             // } else {
  //             //   for (
  //             //     let i = 0;
  //             //     i < this.moduleList.sectionScoreDetails.length;
  //             //     i++
  //             //   ) {
  //             //     if (
  //             //       this.moduleList.sectionScoreDetails[i].sectionId !==
  //             //       sectionScoreDetailObj.sectionId
  //             //     ) {
  //             //       this.moduleList.sectionScoreDetails.push(
  //             //         sectionScoreDetailObj
  //             //       );
  //             //       break;
  //             //     }
  //             //     break;
  //             //   }
  //             // this.moduleList.sectionScoreDetails.forEach(
  //             //   (
  //             //     sectionScoreDetailObjOfLoop,
  //             //     sectionScoreDetailObjOfLoopIndex
  //             //   ) => {
  //             //     if (
  //             //       sectionScoreDetailObj.sectionId !==
  //             //       sectionScoreDetailObjOfLoop.sectionId
  //             //     ) {
  //             //       this.moduleList.sectionScoreDetails.push(
  //             //         sectionScoreDetailObj
  //             //       );
  //             //       break;
  //             //     }
  //             //     // if (
  //             //     //   sectionScoreDetailObj.sectionId !==
  //             //     //   sectionScoreDetailObjOfLoop.sectionId
  //             //     // ) {
  //             //     //   this.moduleList.sectionScoreDetails.push(
  //             //     //     sectionScoreDetailObj
  //             //     //   );
  //             //     // }
  //             //   }
  //             // );
  //             // }
  //             if (section.topicAndSubTopicsList.length > 0) {
  //               section.topicAndSubTopicsList.forEach(
  //                 (topicAndSubTopics: any, topicAndSubTopicsIndex: any) => {
  //                   if (topicAndSubTopics.subtopics) {
  //                     topicAndSubTopics.subtopics.forEach(
  //                       (subTopic: any, subTopicIndex: any) => {
  //                         console.log(
  //                           testSubTopic.subTopicId,
  //                           subTopic.subtopic_id
  //                         );
  //                         if (
  //                           testSubTopic.subTopicId === subTopic.subtopic_id
  //                         ) {
  //                           console.log(
  //                             testSubTopic.questionSpecifications[0]
  //                               .noOfQuestions
  //                           );
  //                           yo.push(
  //                             testSubTopic.questionSpecifications[0]
  //                               .noOfQuestions
  //                           );
  //                           for (
  //                             let noOfQuestions = 0;
  //                             noOfQuestions <
  //                             testSubTopic.questionSpecifications[0]
  //                               .noOfQuestions;
  //                             noOfQuestions++
  //                           ) {
  //                             let scoreDetailObj: ScoreDetail = {
  //                               rawScore: noOfQuestions + 1,
  //                               score: 0,
  //                             };
  //                             this.moduleList.sectionScoreDetails.forEach(
  //                               (
  //                                 sectionScoreDetail,
  //                                 sectionScoreDetailIndex
  //                               ) => {
  //                                 console.log(
  //                                   section.tst_id,
  //                                   sectionScoreDetail.sectionId
  //                                 );
  //                                 if (
  //                                   section.tst_id ===
  //                                   sectionScoreDetail.sectionId
  //                                 ) {
  //                                   sectionScoreDetail.scoreDetails.push(
  //                                     scoreDetailObj
  //                                   );
  //                                 }
  //                               }
  //                             );
  //                           }
  //                         }
  //                       }
  //                     );
  //                   } else {
  //                     console.log('No subtopics');
  //                   }
  //                 }
  //               );
  //             } else {
  //               console.log('list is empty');
  //             }
  //           });
  //           this.moduleList.sectionScoreDetails =
  //             this.moduleList.sectionScoreDetails.filter(
  //               (sectionScoreDetailObj) =>
  //                 sectionScoreDetailObj.scoreDetails.length > 0
  //             );
  //         }
  //       );
  //     }
  //   );
  //   console.log(yo);
  //   console.log(this.moduleList);
  // }
}
